module.exports = __webpack_public_path__ + "media/images/athletes/80-03aa2f91f903341bd6baa7b2456543d1.png";